import { Container, Sprite, Text } from '@pixi/react';
import { TextStyle, Texture } from 'pixi.js';
import { useGameStore } from '../../store/gameSlice';
import { ITEMS } from '../../data/inventory.config';
import { PickupNotification } from '../../types/inventory.types';
import { useSpritesStore } from '../../store';
import { resolveIconTexture } from '../../utils/iconTexture.utils';

interface Props {
  notification: PickupNotification;
}

export const PickupNotificationDisplay = ({ notification }: Props) => {
  const zoomFactor = useGameStore((s) => s.zoomFactor);
  const allTextures = useSpritesStore((s) => s.textures);

  const { itemId, quantity, worldX, worldY, elapsed, delay, duration } =
    notification;
  const item = ITEMS[itemId];

  // Hide while still waiting in the stagger queue.
  if (!item || elapsed < delay) {
    return null;
  }

  const progress = Math.min((elapsed - delay) / duration, 1);

  const iconTexture: Texture | undefined = resolveIconTexture(
    allTextures,
    item.sprite,
  );
  const label = quantity > 1 ? `${item.label}  ×${quantity}` : item.label;
  const iconSize = 8 * zoomFactor;
  const fontSize = 9 * zoomFactor;
  const floatOffset = progress * 36 * zoomFactor;

  const x = worldX * zoomFactor;
  const y = -worldY * zoomFactor - floatOffset;

  return (
    <Container x={x} y={y} alpha={1 - progress} zIndex={110}>
      {iconTexture && (
        <Sprite
          texture={iconTexture}
          anchor={[1, 0.5]}
          x={-4}
          y={0}
          width={iconSize}
          height={iconSize}
        />
      )}
      <Text
        text={label}
        anchor={[0, 0.5]}
        x={0}
        y={0}
        zIndex={110}
        style={
          {
            fontSize,
            fill: '#f0d080',
            fontWeight: 'bold',
            stroke: '#000000',
            strokeThickness: 3,
          } as TextStyle
        }
      />
    </Container>
  );
};
